import { AnySchema } from "yup";

type TErrors = {
  schema: AnySchema;
  stateData: object;
  setErrorMessage: Function;
};

export default function handleErrors({
  schema,
  stateData,
  setErrorMessage,
}: TErrors) {
  let yup_errors = {};
  schema.validate(stateData, { abortEarly: false }).catch((err) => {
    for (let error of err.inner) {
      const { path, message } = error;
      Object.assign(yup_errors, { [path]: message });
    }
    return setErrorMessage(yup_errors);
  });
}
